<!-- <div class="row m-0 mt-3"> -->
<div [class.FixHeight]="PageAcess[0].View == 0">
  <div class="row mt-2" *ngIf="PageAcess[0].View == 1">
    <div class="col-md-12">
      <div class="table-responsive">
        <mat-table
          [dataSource]="dataCSource"
          matSort
          matTableExporter
          style="max-width: 100%; overflow: auto"
        >
          <ng-container matColumnDef="Int_Id">
            <mat-header-cell
              mat-sort-header
              class="grid-header"
              style="max-width: 3.125rem"
              *matHeaderCellDef
            >
              #
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row; let i = index"
              class="grid-cell"
              style="max-width: 3.125rem; max-height: 0.3125rem"
            >
              {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Type">
            <mat-header-cell class="grid-header" *matHeaderCellDef
              >Type</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.Type
            }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="Name">
            <mat-header-cell class="grid-header" *matHeaderCellDef
              >Name</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.Name
            }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="Company Name">
            <mat-header-cell class="grid-header" *matHeaderCellDef
              >Company Name</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.CompanyName
            }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="IDV/Sum Assured">
            <mat-header-cell class="grid-header" *matHeaderCellDef
              >IDV/Sum Assured</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.IDVOrSumAssured
            }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="Expire Date">
            <mat-header-cell class="grid-header" *matHeaderCellDef
              >Expire Date</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">{{
              row.ExpireDate
            }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="View Detail">
            <mat-header-cell
              class="grid-header j-c-center"
              style="max-height: 0.3125rem"
              *matHeaderCellDef
              >View Detail</mat-header-cell
            >
            <mat-cell
              *matCellDef="let row"
              class="grid-cell j-c-center"
              style="max-width: 9.375rem; max-height: 0.3125rem"
            >
              <i
                class="fa fa-eye"
                style="font-size: large"
                (click)="goToDetail(row)"
                aria-label="true"
              ></i>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Action">
            <mat-header-cell
              class="grid-header j-c-center"
              style="max-height: 0.3125rem"
              *matHeaderCellDef
              >Action</mat-header-cell
            >
            <mat-cell
              *matCellDef="let row"
              class="grid-cell j-c-center"
              style="max-width: 9.375rem; max-height: 0.3125rem"
            >
              <i
                class="fas fa-lg fa-edit margin-right-4xs cursor-style"
                (click)="goToUpdate(row)"
                aria-label="true"
                *ngIf="
                  PageAcess && PageAcess[0].Edit == 1 && !loanSummary.CloseDate
                "
              ></i>
              <i
                class="fa fa-trash style-delete ml-3"
                (click)="Delete(row)"
                aria-label="true"
                *ngIf="PageAcess[0].Delete == 1 && !loanSummary.CloseDate"
              ></i>
            </mat-cell>
          </ng-container>
          <mat-header-row
            *matHeaderRowDef="displayedInsuranceColumns; sticky: true"
          ></mat-header-row>
          <mat-row
            *matRowDef="let row; columns: displayedInsuranceColumns"
          ></mat-row>
        </mat-table>

        <div class="row m-0 align-items-center">
          <div class="col-md-4"></div>
          <div class="col-md-8">
            <mat-paginator
              #paginatorRef
              [pageSizeOptions]="[20, 50]"
              showFirstLastButtons
            >
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="lms-sticky-actions row m-0 mt-2">
  <div class="col-md-6">
    <div *ngIf="PageAcess[0].View == 1">
      <button
        type="button"
        (click)="OpenModelInsurance()"
        class="mt-2 btn font-size-12 button-btn"
        [class.spinner]="loading"
        *ngIf="PageAcess && PageAcess[0].Add == 1 && !loanSummary.CloseDate"
      >
        Add Insurance Detail
      </button>
    </div>
  </div>
  <div class="col-md-6 text-right">
    <button
      type="button"
      (click)="onNext()"
      class="ml-4 mt-2 btn font-size-12 button-btn"
      [class.spinner]="loading"
    >
      Next <i class="fa fa-arrow-right"></i>
    </button>
  </div>
</div>

<div
  class="modal fade in"
  id="InsuranceModel"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Add Insurance Detail
        </h6>
        <button
          type="button"
          (click)="onCloseInsurance()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><i class="far text-black fa-times-circle"></i
          ></span>
        </button>
      </div>
      <div class="modal-body">
        <form #rdf="ngForm" novalidate class="formborder">
          <div class="row m-0 col-md-12 p-0">
            <div class="col-md-6">
              <span class="required-lable">Insurance Type</span>
              <select
                name="Type"
                id="Type"
                #refType="ngModel"
                (change)="ShowForm($event)"
                [ngClass]="{
                  'is-invalid': rdf.submitted && refType.invalid,
                  'alert-warning':
                    refType.invalid &&
                    (refType.dirty || refType.touched || refType.untouched)
                }"
                [(ngModel)]="Type"
                class="form-control input-text-css"
                required
              >
                <option value="Assets" selected>Assets</option>
                <option value="Customer">Customer</option>
              </select>
            </div>
            <div class="col-md-6">
              <span class="required-lable"> Customer/Assets Name</span>
              <select
                name="Id"
                id="Id"
                #refId="ngModel"
                [ngClass]="{
                  'is-invalid': rdf.submitted && refId.invalid,
                  'alert-warning':
                    refId.invalid &&
                    (refId.dirty || refId.touched || refId.untouched)
                }"
                [(ngModel)]="Id"
                (change)="onCustomerAssetChange($event.target.value)"
                class="form-control input-text-css"
                required
              >
                <option value="">Select Customer/Assets Name</option>
                <option
                  *ngFor="let list of CustomerAssetsList"
                  [value]="list.CustomerId"
                >
                  {{ list.Customer }}
                </option>
              </select>
            </div>
          </div>
          <div [hidden]="!AssetsShow">
            <div class="row m-0 col-md-12 p-0">
              <div class="col-md-4">
                <span class="required-lable">Insurance Company </span>
                <!--<input type="text" [(ngModel)]="AssetInsuranceCompany"
                       placeholder="Insurance Company"
                       name="company" id="company" class="form-control input-text-css">-->
                <select
                  name="AssetInsuranceCompany"
                  id="AssetInsuranceCompany"
                  #refAssetInsuranceCompany="ngModel"
                  (change)="getInsuranceBranch($event)"
                  [ngClass]="{
                    'is-invalid':
                      rdf.submitted && refAssetInsuranceCompany.invalid,
                    'alert-warning':
                      refAssetInsuranceCompany.invalid &&
                      (refId.dirty ||
                        refAssetInsuranceCompany.touched ||
                        refAssetInsuranceCompany.untouched)
                  }"
                  [(ngModel)]="AssetInsuranceCompany"
                  class="form-control input-text-css"
                  required
                >
                  <option value="">Select Insurance Company</option>
                  <option
                    *ngFor="let list of Insurance_Company_List"
                    [value]="list.Int_Id"
                  >
                    {{ list.Insurance_company }}
                  </option>
                </select>
              </div>
              <div class="col-md-4">
                <span class="required-lable">Insurance Company Branch </span>
                <!--<input type="text" [(ngModel)]="AssetInsuranceCompanyBranch" placeholder="Insurance Company Branch Name"
                       name="branch" id="branch" class="form-control input-text-css">-->
                <select
                  name="branch"
                  id="branch"
                  #refbranch="ngModel"
                  [ngClass]="{
                    'is-invalid': rdf.submitted && refbranch.invalid,
                    'alert-warning':
                      refbranch.invalid &&
                      (refbranch.dirty ||
                        refbranch.touched ||
                        refbranch.untouched)
                  }"
                  [(ngModel)]="AssetInsuranceCompanyBranch"
                  class="form-control input-text-css"
                  required
                >
                  <option value="">Select Branch Name</option>
                  <option
                    *ngFor="let list of Insurance_Branch_List"
                    [value]="list.Int_Id"
                  >
                    {{ list.Insurance_Branch }}
                  </option>
                </select>
              </div>
              <div class="col-md-4">
                <span class="required-lable">Agent Name </span>
                <input
                  type="text"
                  #refAssetAgentName="ngModel"
                  required
                  maxLength="30"
                  [ngClass]="{
                    'is-invalid': rdf.submitted && refAssetAgentName.invalid,
                    'alert-warning':
                      refAssetAgentName.invalid &&
                      (refAssetAgentName.dirty ||
                        refAssetAgentName.touched ||
                        refAssetAgentName.untouched)
                  }"
                  [(ngModel)]="AssetAgentName"
                  name="AssetAgentName"
                  id="AssetAgentName"
                  class="form-control input-text-css"
                />
              </div>
            </div>

            <div class="row m-0 col-md-12 p-0">
              <div class="col-md-4">
                <span class="required-lable">Insurance Date</span>
                <div class="datepicker_feild">
                  <input
                    [matDatepicker]="picker"
                    dateConvert
                    placeholder="DD/MM/YYYY"
                    name="First_EMI_Date1"
                    [(ngModel)]="AssetInsuranceDate"
                    (dateChange)="changeAssetRenewalDate($event)"
                    id="First_EMI_Date1"
                    #refAssetInsuranceDate="ngModel"
                    required
                    [ngClass]="{
                      'is-invalid':
                        rdf.submitted && refAssetInsuranceDate.invalid,
                      'alert-warning':
                        refAssetInsuranceDate.invalid &&
                        (refAssetInsuranceDate.dirty ||
                          refAssetInsuranceDate.touched ||
                          refAssetInsuranceDate.untouched)
                    }"
                    class="form-control input-text-css"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </div>
                <!-- <input name="First_EMI_Date1" [(ngModel)]="AssetInsuranceDate" (ngModelChange)="changeAssetRenewalDate($event)" 
                  id="First_EMI_Date1" [minDate]="CurrentDate" #refAssetInsuranceDate="ngModel" required
                  [ngClass]="{ 'is-invalid': rdf.submitted && refAssetInsuranceDate.invalid, 'alert-warning': refAssetInsuranceDate.invalid  && (refAssetInsuranceDate.dirty || refAssetInsuranceDate.touched || refAssetInsuranceDate.untouched) }"
                  placeholder="DD/MM/YYYY" class="form-control input-text-css" bsDatepicker> -->
                <!-- <input
                  name="First_EMI_Date1"
                  [(ngModel)]="AssetInsuranceDate"
                  (ngModelChange)="changeAssetRenewalDate($event)"
                  id="First_EMI_Date1"
                  #refAssetInsuranceDate="ngModel"
                  required
                  [ngClass]="{
                    'is-invalid':
                      rdf.submitted && refAssetInsuranceDate.invalid,
                    'alert-warning':
                      refAssetInsuranceDate.invalid &&
                      (refAssetInsuranceDate.dirty ||
                        refAssetInsuranceDate.touched ||
                        refAssetInsuranceDate.untouched)
                  }"
                  placeholder="DD/MM/YYYY"
                  class="form-control input-text-css"
                  bsDatepicker
                /> -->
              </div>

              <div class="col-md-4">
                <span class="required-lable">Renewal Date</span>
                <div class="datepicker_feild">
                  <input
                    [matDatepicker]="picker2"
                    dateConvert
                    placeholder="DD/MM/YYYY"
                    name="First_EMI_Date2"
                    [(ngModel)]="AssetRenewalDate"
                    (dateChange)="changeRenewalDate($event)"
                    id="First_EMI_Date2"
                    [min]="getMinRenewalDate()"
                    #refAssetRenewalDate="ngModel"
                    required
                    [ngClass]="{
                      'is-invalid':
                        rdf.submitted && refAssetRenewalDate.invalid,
                      'alert-warning':
                        refAssetRenewalDate.invalid &&
                        (refAssetRenewalDate.dirty ||
                          refAssetRenewalDate.touched ||
                          refAssetRenewalDate.untouched)
                    }"
                    class="form-control input-text-css"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker2"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </div>
                <!-- <input
                  name="First_EMI_Date2"
                  [(ngModel)]="AssetRenewalDate"
                  (ngModelChange)="changeRenewalDate($event)"
                  id="First_EMI_Date2"
                  [minDate]="AssetInsuranceDate"
                  #refAssetRenewalDate="ngModel"
                  required
                  [ngClass]="{
                    'is-invalid': rdf.submitted && refAssetRenewalDate.invalid,
                    'alert-warning':
                      refAssetRenewalDate.invalid &&
                      (refAssetRenewalDate.dirty ||
                        refAssetRenewalDate.touched ||
                        refAssetRenewalDate.untouched)
                  }"
                  placeholder="DD/MM/YYYY"
                  class="form-control input-text-css"
                  bsDatepicker
                /> -->
              </div>

              <div class="col-md-4">
                <span class="required-lable">Cover Note No/Policy No.</span>
                <input
                  type="text"
                  [(ngModel)]="AssetCoverNoteNo"
                  placeholder="Cover Note No/Policy No."
                  name="covernote"
                  id="covernote"
                  #refAssetCoverNoteNo="ngModel"
                  required
                  maxLength="30"
                  [ngClass]="{
                    'is-invalid': rdf.submitted && refAssetCoverNoteNo.invalid,
                    'alert-warning':
                      refAssetCoverNoteNo.invalid &&
                      (refAssetCoverNoteNo.dirty ||
                        refAssetCoverNoteNo.touched ||
                        refAssetCoverNoteNo.untouched)
                  }"
                  class="form-control input-text-css"
                />
              </div>
            </div>

            <div class="row m-0 col-md-12 p-0">
              <div class="col-md-4">
                <span class="required-lable">Policy Type</span>
                <!--<input type="text" [(ngModel)]="AssetPolicyType"
                       placeholder="Policy Type"
                       name="policyType" id="policyType" class="form-control input-text-css">-->
                <select
                  name="policyType"
                  id="policyType"
                  #refpolicyType="ngModel"
                  [ngClass]="{
                    'is-invalid': rdf.submitted && refpolicyType.invalid,
                    'alert-warning':
                      refpolicyType.invalid &&
                      (refpolicyType.dirty ||
                        refpolicyType.touched ||
                        refpolicyType.untouched)
                  }"
                  [(ngModel)]="AssetPolicyType"
                  class="form-control input-text-css"
                  required
                >
                  <option value="">Select Policy Type</option>
                  <option
                    *ngFor="let Type of PolicyTypeAssetsOption"
                    [value]="Type.Id"
                  >
                    {{ Type.Value }}
                  </option>
                </select>
              </div>
              <div class="col-md-4">
                <span class="required-lable">IDV Amount</span>
                <input
                  type="number"
                  [(ngModel)]="AssetIDVAmount"
                  placeholder="IDV Amount"
                  name="IDV"
                  id="IDV"
                  class="form-control input-text-css"
                  #refAssetIDVAmount="ngModel"
                  required
                  onkeydown="notDecimal(event)"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                  [ngClass]="{
                    'is-invalid': rdf.submitted && refAssetIDVAmount.invalid,
                    'alert-warning':
                      refAssetIDVAmount.invalid &&
                      (refAssetIDVAmount.dirty ||
                        refAssetIDVAmount.touched ||
                        refAssetIDVAmount.untouched)
                  }"
                />
              </div>
              <div class="col-md-4">
                <span>Premium Amount</span>
                <input
                  type="number"
                  [(ngModel)]="AssetPremiumAmount"
                  placeholder="Premium Amount"
                  name="PremiumAmount"
                  id="PremiumAmount"
                  #refAssetPremiumAmount="ngModel"
                  required
                  onkeydown="notDecimal(event)"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                  [ngClass]="{
                    'is-invalid':
                      rdf.submitted && refAssetPremiumAmount.invalid,
                    'alert-warning':
                      refAssetPremiumAmount.invalid &&
                      (refAssetPremiumAmount.dirty ||
                        refAssetPremiumAmount.touched ||
                        refAssetPremiumAmount.untouched)
                  }"
                  class="form-control input-text-css"
                />
              </div>
            </div>

            <div class="row m-0 col-md-12 p-0">
              <div class="col-md-4">
                <span class="required-lable">Nominee Name</span>
                <input
                  type="text"
                  [(ngModel)]="AssetNomineeName"
                  placeholder="Nominee Name"
                  name="Nominee"
                  id="Nominee"
                  class="form-control input-text-css"
                  #refAssetNomineeName="ngModel"
                  required
                  maxLength="30"
                  [ngClass]="{
                    'is-invalid': rdf.submitted && refAssetNomineeName.invalid,
                    'alert-warning':
                      refAssetNomineeName.invalid &&
                      (refAssetNomineeName.dirty ||
                        refAssetNomineeName.touched ||
                        refAssetNomineeName.untouched)
                  }"
                />
              </div>
              <div class="col-md-4">
                <span class="required-lable"
                  >Nominee Relation with Borrower</span
                >
                <!--<input type="text" [(ngModel)]="AssetNomineeRelationwithHirer"
                       placeholder="Nominee Relation with Borrower"
                       name="Relation" id="Relation" class="form-control input-text-css">-->
                <select
                  name="Relation"
                  id="Relation"
                  #refRelation="ngModel"
                  [ngClass]="{
                    'is-invalid': rdf.submitted && refRelation.invalid,
                    'alert-warning':
                      refRelation.invalid &&
                      (refRelation.dirty ||
                        refRelation.touched ||
                        refRelation.untouched)
                  }"
                  [(ngModel)]="AssetNomineeRelationwithHirer"
                  class="form-control input-text-css"
                  required
                >
                  <option *ngFor="let Type of RelationList" [value]="Type.Id">
                    {{ Type.Value }}
                  </option>
                </select>
              </div>

              <div class="col-md-4">
                <span class="required-lable">Nominee DOB</span>
                <div class="datepicker_feild">
                  <input
                    [matDatepicker]="picker5"
                    dateConvert
                    placeholder="DD/MM/YYYY"
                    name="NomineeDOBAssets"
                    [(ngModel)]="NomineeDOBAssets"
                    id="NomineeDOBAssets"
                    #refNomineeDOBAssets="ngModel"
                    required
                    [ngClass]="{
                      'is-invalid':
                        rdf.submitted && refNomineeDOBAssets.invalid,
                      'alert-warning':
                        refNomineeDOBAssets.invalid &&
                        (refNomineeDOBAssets.dirty ||
                          refNomineeDOBAssets.touched ||
                          refNomineeDOBAssets.untouched)
                    }"
                    class="form-control input-text-css"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker5"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker5></mat-datepicker>
                </div>
              </div>

              <div class="col-md-4">
                <input
                  style="margin: 1.25rem 0px 0px 0px; height: 1.5rem; width: 1.375rem"
                  (change)="InsuranceEndorsedChange($event)"
                  class="form-check-input"
                  type="checkbox"
                  name="exampleRadios1"
                  id="Endorsed1"
                  value="option2"
                />
                <label
                  style="margin: 1.1875rem 0px 0px 1.9375rem"
                  class="form-check-label"
                  for="exampleRadios1"
                  >Insurance endorsed</label
                >
              </div>
            </div>

            <div class="row m-0 mt-3 col-md-12 p-0 justify-content-end">
              <button
                type="button"
                *ngIf="SelectedAssetId"
                (click)="ViewData()"
                aria-label="true"
                class="mt-3 btn font-size-12 button-btn mr-3"
              >
                View Assets Detail
              </button>
              <button
                type="button"
                (click)="onCloseInsurance()"
                class="mt-3 btn font-size-12 button-btn mr-3"
              >
                Cancel
              </button>
              <button
                type="button"
                (click)="onSaveAssetsDetail()"
                class="mt-3 btn font-size-12 button-btn"
                [class.spinner]="loading"
                [hidden]="!isShowSave"
                [disabled]="!rdf.form.valid"
              >
                Save
              </button>
              <button
                type="button"
                (click)="onSaveAssetsDetail()"
                class="mt-3 btn font-size-12 button-btn"
                [class.spinner]="loading"
                [hidden]="!isShowUpdate"
                [disabled]="!rdf.form.valid"
              >
                Update
              </button>
            </div>
          </div>

          <div class="row m-0 col-md-12 p-0" [hidden]="!CustomerShow">
            <form #ddf="ngForm" novalidate>
              <div class="row m-0 col-md-12 p-0">
                <div class="row m-0 col-md-12 p-0">
                  <div class="col-md-4">
                    <span class="required-lable">Insurance Company</span>

                    <select
                      name="Asset_Cost1"
                      id="Asset_Cost1"
                      (change)="getInsuranceBranch($event)"
                      #refAsset_Cost1="ngModel"
                      [ngClass]="{
                        'is-invalid': ddf.submitted && refAsset_Cost1.invalid,
                        'alert-warning':
                          refAsset_Cost1.invalid &&
                          (refAsset_Cost1.dirty ||
                            refAsset_Cost1.touched ||
                            refAsset_Cost1.untouched)
                      }"
                      [(ngModel)]="CustomerInsHirerLifeInsCmny"
                      class="form-control input-text-css"
                      required
                    >
                      <option value="">Select Insurance Company</option>
                      <option
                        *ngFor="let list of Insurance_Company_List"
                        [value]="list.Int_Id"
                      >
                        {{ list.Insurance_company }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <span class="required-lable"
                      >Insurance Company Branch Name
                    </span>

                    <select
                      name="Asset_Cost2"
                      id="Asset_Cost2"
                      class="form-control input-text-css"
                      [(ngModel)]="CustomerInsAssetInsuranceCompanyBranch"
                      #refAsset_Cost2="ngModel"
                      required
                      [ngClass]="{
                        'is-invalid': ddf.submitted && refAsset_Cost2.invalid,
                        'alert-warning':
                          refAsset_Cost2.invalid &&
                          (refAsset_Cost2.dirty ||
                            refAsset_Cost2.touched ||
                            refAsset_Cost2.untouched)
                      }"
                    >
                      <option value="">Select Branch Name</option>
                      <option
                        *ngFor="let list of Insurance_Branch_List"
                        [value]="list.Int_Id"
                      >
                        {{ list.Insurance_Branch }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <span class="required-lable">Agent Name </span>
                    <input
                      type="text"
                      [(ngModel)]="CustomerInsAgentName"
                      placeholder="Agent Name"
                      name="Asset_Cost3"
                      id="Asset_Cost3"
                      class="form-control input-text-css"
                      #refAsset_Cost3="ngModel"
                      required
                      [ngClass]="{
                        'is-invalid': ddf.submitted && refAsset_Cost3.invalid,
                        'alert-warning':
                          refAsset_Cost3.invalid &&
                          (refAsset_Cost3.dirty ||
                            refAsset_Cost3.touched ||
                            refAsset_Cost3.untouched)
                      }"
                    />
                  </div>
                </div>

                <div class="row m-0 col-md-12 p-0">
                  <div class="col-md-4">
                    <span class="required-lable">Insurance Date</span>
                    <div class="datepicker_feild">
                      <input
                        [matDatepicker]="picker3"
                        dateConvert
                        placeholder="DD/MM/YYYY"
                        name="First_EMI_Date3"
                        [(ngModel)]="CustomerInsInsuranceDate"
                        (dateChange)="changeInsuranceDate($event)"
                        id="First_EMI_Date3"
                        class="form-control input-text-css"
                        #refFirst_EMI_Date3="ngModel"
                        required
                        [ngClass]="{
                          'is-invalid':
                            ddf.submitted && refFirst_EMI_Date3.invalid,
                          'alert-warning':
                            refFirst_EMI_Date3.invalid &&
                            (refFirst_EMI_Date3.dirty ||
                              refFirst_EMI_Date3.touched ||
                              refFirst_EMI_Date3.untouched)
                        }"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="picker3"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #picker3></mat-datepicker>
                    </div>

                    <!-- <input
                      name="First_EMI_Date3"
                      [(ngModel)]="CustomerInsInsuranceDate"
                      (ngModelChange)="changeInsuranceDate($event)"
                      id="First_EMI_Date3"
                      placeholder="DD/MM/YYYY"
                      class="form-control input-text-css"
                      bsDatepicker
                      #refFirst_EMI_Date3="ngModel"
                      required
                      [ngClass]="{
                        'is-invalid':
                          ddf.submitted && refFirst_EMI_Date3.invalid,
                        'alert-warning':
                          refFirst_EMI_Date3.invalid &&
                          (refFirst_EMI_Date3.dirty ||
                            refFirst_EMI_Date3.touched ||
                            refFirst_EMI_Date3.untouched)
                      }"
                    /> -->
                  </div>
                  <div class="col-md-4">
                    <span class="required-lable">Expire Date</span>
                    <div class="datepicker_feild">
                      <input
                        [matDatepicker]="picker4"
                        dateConvert
                        placeholder="DD/MM/YYYY"
                        name="First_EMI_Date4"
                        [(ngModel)]="CustomerInsExpireDate"
                        [min]="CustomerInsInsuranceDate"
                        (dateChange)="changeExpireDate($event)"
                        id="First_EMI_Date4"
                        class="form-control input-text-css"
                        #refFirst_EMI_Date4="ngModel"
                        required
                        [ngClass]="{
                          'is-invalid':
                            ddf.submitted && refFirst_EMI_Date4.invalid,
                          'alert-warning':
                            refFirst_EMI_Date4.invalid &&
                            (refFirst_EMI_Date4.dirty ||
                              refFirst_EMI_Date4.touched ||
                              refFirst_EMI_Date4.untouched)
                        }"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="picker4"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #picker4></mat-datepicker>
                    </div>
                    <!-- <input
                      name="First_EMI_Date4"
                      [(ngModel)]="CustomerInsExpireDate"
                      [minDate]="CustomerInsInsuranceDate"
                      (ngModelChange)="changeExpireDate($event)"
                      id="First_EMI_Date4"
                      placeholder="DD/MM/YYYY"
                      class="form-control input-text-css"
                      bsDatepicker
                      #refFirst_EMI_Date4="ngModel"
                      required
                      [ngClass]="{
                        'is-invalid':
                          ddf.submitted && refFirst_EMI_Date4.invalid,
                        'alert-warning':
                          refFirst_EMI_Date4.invalid &&
                          (refFirst_EMI_Date4.dirty ||
                            refFirst_EMI_Date4.touched ||
                            refFirst_EMI_Date4.untouched)
                      }" -->
                  </div>
                  <div class="col-md-4">
                    <span class="required-lable">policy No</span>
                    <input
                      type="text"
                      [(ngModel)]="CustomerInsPolicyNo"
                      placeholder="Policy No"
                      name="Policy1"
                      id="Policy1"
                      class="form-control input-text-css"
                      #refPolicy1="ngModel"
                      required
                      [ngClass]="{
                        'is-invalid': ddf.submitted && refPolicy1.invalid,
                        'alert-warning':
                          refPolicy1.invalid &&
                          (refPolicy1.dirty ||
                            refPolicy1.touched ||
                            refPolicy1.untouched)
                      }"
                    />
                  </div>
                </div>

                <div class="row m-0 col-md-12 p-0">
                  <div class="col-md-4">
                    <span class="required-lable">Policy Type</span>

                    <select
                      name="Type1"
                      id="Type1"
                      #refSelectGender="ngModel"
                      [(ngModel)]="CustomerInsPolicyType"
                      class="form-control input-text-css"
                      #refType1="ngModel"
                      required
                      [ngClass]="{
                        'is-invalid': ddf.submitted && refType1.invalid,
                        'alert-warning':
                          refType1.invalid &&
                          (refType1.dirty ||
                            refType1.touched ||
                            refType1.untouched)
                      }"
                    >
                      <option value="">Select Policy Type</option>
                      <option
                        *ngFor="let Type of PolicyTypeCustomerOption"
                        [value]="Type.Id"
                      >
                        {{ Type.Value }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <span class="required-lable">Sum Assured</span>
                    <input
                      type="number"
                      [(ngModel)]="CustomerInsSumAssured"
                      placeholder="Sum Assured"
                      name="Sum"
                      id="Sum"
                      class="form-control input-text-css"
                      #refSum="ngModel"
                      required
                      [ngClass]="{
                        'is-invalid': ddf.submitted && refSum.invalid,
                        'alert-warning':
                          refSum.invalid &&
                          (refSum.dirty || refSum.touched || refSum.untouched)
                      }"
                    />
                  </div>
                  <div class="col-md-4">
                    <span class="required-lable">Premium Amount</span>
                    <input
                      type="number"
                      [(ngModel)]="CustomerInsPremiumAmount"
                      placeholder="Premium Amount"
                      name="Amount1"
                      id="Amount1"
                      class="form-control input-text-css"
                      #refAmount1="ngModel"
                      required
                      [ngClass]="{
                        'is-invalid': ddf.submitted && refAmount1.invalid,
                        'alert-warning':
                          refAmount1.invalid &&
                          (refAmount1.dirty ||
                            refAmount1.touched ||
                            refAmount1.untouched)
                      }"
                    />
                  </div>
                </div>

                <div class="row m-0 col-md-12 p-0">
                  <div class="col-md-4">
                    <span class="required-lable">Nominee Name</span>
                    <input
                      type="text"
                      [(ngModel)]="CustomerInsNomineeName"
                      placeholder="Nominee Name"
                      name="Nominee1"
                      id="Nominee1"
                      class="form-control input-text-css"
                      #refNominee1="ngModel"
                      required
                      [ngClass]="{
                        'is-invalid': ddf.submitted && refNominee1.invalid,
                        'alert-warning':
                          refNominee1.invalid &&
                          (refNominee1.dirty ||
                            refNominee1.touched ||
                            refNominee1.untouched)
                      }"
                    />
                  </div>
                  <div class="col-md-4">
                    <span class="required-lable"
                      >Nominee Relation with Borrower</span
                    >

                    <select
                      name="Relation1"
                      id="Relation1"
                      #refSelectRelation="ngModel"
                      [(ngModel)]="AssetNomineeRelationwithHirer"
                      class="form-control input-text-css"
                      #refRelation1="ngModel"
                      required
                      [ngClass]="{
                        'is-invalid': ddf.submitted && refRelation1.invalid,
                        'alert-warning':
                          refRelation1.invalid &&
                          (refRelation1.dirty ||
                            refRelation1.touched ||
                            refRelation1.untouched)
                      }"
                    >
                      <option
                        *ngFor="let Type of RelationList"
                        [value]="Type.Id"
                      >
                        {{ Type.Value }}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-4">
                    <span class="required-lable">Nominee DOB</span>
                    <div class="datepicker_feild">
                      <input
                        [matDatepicker]="picker6"
                        dateConvert
                        placeholder="DD/MM/YYYY"
                        name="NomineeDOBAssets1"
                        [(ngModel)]="NomineeDOBCustomer"
                        id="NomineeDOBCustomer1"
                        #refNomineeDOBCustomer="ngModel"
                        required
                        [ngClass]="{
                          'is-invalid':
                            rdf.submitted && refNomineeDOBCustomer.invalid,
                          'alert-warning':
                            refNomineeDOBCustomer.invalid &&
                            (refNomineeDOBCustomer.dirty ||
                              refNomineeDOBCustomer.touched ||
                              refNomineeDOBCustomer.untouched)
                        }"
                        class="form-control input-text-css"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="picker6"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #picker6></mat-datepicker>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <input
                      style="
                        margin: 1.25rem 0px 0px 0px;
                        height: 1.5rem;
                        width: 1.375rem;
                      "
                      (change)="NomineeRelationHirerChange($event)"
                      class="form-check-input"
                      type="checkbox"
                      name="exampleRadios2"
                      id="NomineeRelation2"
                      value="option2"
                    />
                    <label
                      style="margin: 1.1875rem 0px 0px 1.9375rem"
                      class="form-check-label"
                      for="exampleRadios2"
                    >
                      Insurance endorsed
                    </label>
                  </div>
                </div>

                <div class="row m-0 mt-3 col-md-12 p-0 justify-content-end">
                  <button
                    type="button"
                    (click)="onCloseInsurance()"
                    class="mt-3 btn font-size-12 button-btn mr-3"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    (click)="onSaveCustomerDetails()"
                    class="mt-3 btn font-size-12 button-btn"
                    [class.spinner]="loading"
                    [hidden]="!isShowSave"
                    [disabled]="!ddf.form.valid"
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    (click)="onSaveCustomerDetails()"
                    class="mt-3 btn font-size-12 button-btn"
                    [class.spinner]="loading"
                    [hidden]="!isShowUpdate"
                    [disabled]="!ddf.form.valid"
                  >
                    Update
                  </button>
                </div>
              </div>
            </form>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade in"
  id="InsuranceDetailModel"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Details
        </h6>
        <button
          type="button"
          (click)="onCloseInsuranceDetail()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body formborder">
        <h1 class="fs-12 h-b">Insurance Details</h1>
        <div class="row m-0 mt-3" [hidden]="!AssetsDetailShow">
          <div class="col-md-2">
            <h6 class="fs-12">Insurance Type</h6>
            <p class="lead fs-12">{{ Type }}</p>
          </div>
          <div class="col-md-2">
            <h6 class="fs-12">{{ Type }} Name</h6>
            <p class="lead fs-12">{{ Name }}</p>
          </div>
          <div class="col-md-2">
            <h6 class="fs-12">Insurance Company</h6>
            <p class="lead fs-12">{{ AssetInsuranceCompanyName }}</p>
          </div>
          <div class="col-md-2">
            <h6 class="fs-12">Insurance Company Branch</h6>
            <p class="lead fs-12">{{ AssetInsuranceCompanyBranchName }}</p>
          </div>
          <div class="col-md-2">
            <h6 class="fs-12">Agent Name</h6>
            <p class="lead fs-12">{{ AssetAgentName }}</p>
          </div>
          <div class="col-md-2">
            <h6 class="fs-12">Insurance Date</h6>
            <p class="lead fs-12">{{ AssetInsuranceDate }}</p>
          </div>
          <div class="col-md-2">
            <h6 class="fs-12">Renewal Date</h6>
            <p class="lead fs-12">{{ AssetRenewalDate }}</p>
          </div>
          <div class="col-md-2">
            <h6 class="fs-12">Cover Note No/Policy No.</h6>
            <p class="lead fs-12">{{ AssetCoverNoteNo }}</p>
          </div>
          <div class="col-md-2">
            <h6 class="fs-12">Policy Type</h6>
            <p class="lead fs-12">{{ AssetPolicyTypeName }}</p>
          </div>
          <div class="col-md-2">
            <h6 class="fs-12">IDV Amount</h6>
            <p class="lead fs-12">{{ AssetIDVAmount }}</p>
          </div>
          <div class="col-md-2">
            <h6 class="fs-12">Premium Amount</h6>
            <p class="lead fs-12">{{ AssetPremiumAmount }}</p>
          </div>
          <div class="col-md-2">
            <h6 class="fs-12">Nominee Name</h6>
            <p class="lead fs-12">{{ AssetNomineeName }}</p>
          </div>
          <div class="col-md-2">
            <h6 class="fs-12">Nominee Relation with Borrower</h6>
            <p class="lead fs-12">{{ AssetNomineeRelationwithHirerName }}</p>
          </div>
          <div class="col-md-2">
            <h6 class="fs-12">Nominee DOB</h6>
            <p class="lead fs-12">{{ NomineeDOBAssets }}</p>
          </div>
          <div class="col-md-2">
            <h6 class="fs-12">Insurance endorsed</h6>
            <p class="lead fs-12">{{ AssetInsuranceEndorsed }}</p>
          </div>
        </div>

        <div class="row m-0 col-md-12 p-0" [hidden]="!CustomerDetailShow">
          <div class="row m-0 col-md-12 p-0">
            <div class="col-md-2">
              <h6 class="fs-12">Insurance Type</h6>
              <p class="lead fs-12">{{ Type }}</p>
            </div>
            <div class="col-md-2">
              <h6 class="fs-12">{{ Type }} Name</h6>
              <p class="lead fs-12">{{ Name }}</p>
            </div>
            <div class="col-md-2">
              <h6 class="fs-12">Insurance Company</h6>
              <p class="lead fs-12">{{ CustomerInsHirerLifeInsCmnyName }}</p>
            </div>
            <div class="col-md-2">
              <h6 class="fs-12">Insurance Company Branch</h6>
              <p class="lead fs-12">
                {{ CustomerInsAssetInsuranceCompanyBranchName }}
              </p>
            </div>
            <div class="col-md-2">
              <h6 class="fs-12">Agent Name</h6>
              <p class="lead fs-12">{{ CustomerInsAgentName }}</p>
            </div>
            <div class="col-md-2">
              <h6 class="fs-12">Insurance Date</h6>
              <p class="lead fs-12">{{ CustomerInsInsuranceDate }}</p>
            </div>
            <div class="col-md-2">
              <h6 class="fs-12">Expiry Date</h6>
              <p class="lead fs-12">{{ CustomerInsExpireDate }}</p>
            </div>
            <div class="col-md-2">
              <h6 class="fs-12">Policy No.</h6>
              <p class="lead fs-12">{{ CustomerInsPolicyNo }}</p>
            </div>
            <div class="col-md-2">
              <h6 class="fs-12">Policy Type</h6>
              <p class="lead fs-12">{{ CustomerInsPolicyTypeName }}</p>
            </div>
            <div class="col-md-2">
              <h6 class="fs-12">Sum Assured</h6>
              <p class="lead fs-12">{{ CustomerInsSumAssured }}</p>
            </div>
            <div class="col-md-2">
              <h6 class="fs-12">Premium Amount</h6>
              <p class="lead fs-12">{{ CustomerInsPremiumAmount }}</p>
            </div>
            <div class="col-md-2">
              <h6 class="fs-12">Nominee Name</h6>
              <p class="lead fs-12">{{ CustomerInsNomineeName }}</p>
            </div>
            <div class="col-md-2">
              <h6 class="fs-12">Nominee Relation with Borrower</h6>
              <p class="lead fs-12">{{ AssetNomineeRelationwithHirerName }}</p>
            </div>
            <div class="col-md-2">
              <h6 class="fs-12">Nominee DOB</h6>
              <p class="lead fs-12">{{ NomineeDOBCustomer }}</p>
            </div>
            <div class="col-md-2">
              <h6 class="fs-12">Insurance endorsed</h6>
              <p class="lead fs-12">{{ CustomerInsNomineeRelationHirer }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div class="modal fade in" id="View" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          {{ Collateral_Type }} [{{ Collateral }}]
        </h6>
        <button type="button" (click)="onCloseView()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body formborder-statement mt-3 ng-star-inserted">
        <ng-container *ngIf="Collateral == 'Property'">
          <div class="row m-0 mt-3" *ngIf="Info">

            <div class="col-md-3" *ngIf="Info.CustomerId">
              <h6 class="font-weight-bold text-dark">Property Owner Name</h6>
              <p class="text-muted">{{ Info.CustomerId }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.Address">
              <h6 class="font-weight-bold text-dark">Address Of Property</h6>
              <p class="text-muted">{{ Info.Address }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.State">
              <h6 class="font-weight-bold text-dark">State</h6>
              <p class="text-muted">{{ Info.State }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.District">
              <h6 class="font-weight-bold text-dark">District</h6>
              <p class="text-muted">{{ Info.District }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.tasil">
              <h6 class="font-weight-bold text-dark">Tehsil</h6>
              <p class="text-muted">{{ Info.tasil }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.PinCode">
              <h6 class="font-weight-bold text-dark">Pincode</h6>
              <p class="text-muted">{{ Info.PinCode }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.TypeofProperty">
              <h6 class="font-weight-bold text-dark">Type of Property</h6>
              <p class="text-muted">{{ Info.TypeofProperty }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.NatureofProperty">
              <h6 class="font-weight-bold text-dark">Nature of Property</h6>
              <p class="text-muted">{{ Info.NatureofProperty }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.OwnershipType">
              <h6 class="font-weight-bold text-dark">Ownership Type</h6>
              <p class="text-muted">{{ Info.OwnershipType }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.OwnershipDocument">
              <h6 class="font-weight-bold text-dark">Ownership Document</h6>
              <p class="text-muted">{{ Info.OwnershipDocument }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.UnitofMeasurement">
              <h6 class="font-weight-bold text-dark">Unit of Measurement</h6>
              <p class="text-muted">{{ Info.UnitofMeasurement }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.TotalArea">
              <h6 class="font-weight-bold text-dark">Total Area</h6>
              <p class="text-muted">{{ Info.TotalArea }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.ConstructedArea">
              <h6 class="font-weight-bold text-dark">Constructed Area</h6>
              <p class="text-muted">{{ Info.ConstructedArea }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.TypeofMortgage">
              <h6 class="font-weight-bold text-dark">Type of Mortgage</h6>
              <p class="text-muted">{{ Info.TypeofMortgage }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.MortgageSingedBy">
              <h6 class="font-weight-bold text-dark">Mortgage Signed By</h6>
              <p class="text-muted">{{ Info.MortgageSingedBy }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.ValuationAmount">
              <h6 class="font-weight-bold text-dark">Valuation Amount</h6>
              <p class="text-muted">{{ Info.ValuationAmount }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.ValuationDoneBy">
              <h6 class="font-weight-bold text-dark">Valuation Done By</h6>
              <p class="text-muted">{{ Info.ValuationDoneBy }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.ValuationRemark">
              <h6 class="font-weight-bold text-dark">Valuation Remark</h6>
              <p class="text-muted">{{ Info.ValuationRemark }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.SearchReportDoneBy">
              <h6 class="font-weight-bold text-dark">Search Report Done By</h6>
              <p class="text-muted">{{ Info.SearchReportDoneBy }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.SearchReportRemark">
              <h6 class="font-weight-bold text-dark">Search Report Remark</h6>
              <p class="text-muted">{{ Info.SearchReportRemark }}</p>
            </div>

            <div class="col-md-3" *ngIf="Info.GeoLocation">
              <h6 class="font-weight-bold text-dark">GeoLocation</h6>
              <p>
                <a target="_blank" [href]="'http://maps.google.com/maps?q=' + Info.GeoLocation"
                  class="btn btn-link p-0 text-primary">
                  <i class="fa-solid fa-location-dot"></i> View Map
                </a>
              </p>
            </div>

            <div class="col-md-3" *ngIf="Info.ValuationRemarkDoc">
              <h6 class="font-weight-bold text-dark">Valuation Report</h6>
              <p>
                <a href="{{ applicationDocUrl }}{{ loanSummary.ApplicationNo }}/{{ Info.ValuationRemarkDoc }}"
                  target="_blank" class="btn btn-outline-primary btn-sm">
                  View Document
                </a>
              </p>
            </div>

            <div class="col-md-3" *ngIf="Info.SearchReportRemarkDoc">
              <h6 class="font-weight-bold text-dark">Search Report</h6>
              <p>
                <a href="{{ applicationDocUrl }}{{ loanSummary.ApplicationNo }}/{{ Info.SearchReportRemarkDoc }}"
                  target="_blank" class="btn btn-outline-primary btn-sm">
                  View Document
                </a>
              </p>
            </div>
          </div>

          <div class="row mt-3" *ngIf="AssetsAttachment.length > 0">
            <div class="col-md-12">
              <h6 class="font-weight-bold">Uploaded Property Images</h6>
              <div class="row mt-2 align-items-center" *ngFor="let report of AssetsAttachment; let i = index">
                <div class="col-md-1">{{ i + 1 }}</div>
                <div class="col-md-4">{{ report.Title }}</div>
                <div class="col-md-4">
                  <a href="{{ applicationDocUrl }}{{ loanSummary.ApplicationNo }}/{{ report.DocFileName }}"
                    target="_blank" *ngIf="report.DocFileName" class="btn btn-outline-secondary btn-sm">
                    {{ report.DocFileName }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="Collateral == 'Vehicle'">
          <div class="row m-0 mt-3 ng-star-inserted" *ngIf="Info">
            <div class="col-md-12">
              <h1 class="fs-12 h-b">{{ Info.Vehicle_SubType }}</h1>
            </div>
            <div class="col-md-2" *ngIf="Info.VehicleManufacture">
              <h6 class="fs-12 font-weight-bold text-dark">Vehicle Manufacture</h6>
              <p class="lead fs-12 text-muted">{{ Info.VehicleManufacture }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.VehicleCategory">
              <h6 class="fs-12 font-weight-bold text-dark">Vehicle Category</h6>
              <p class="lead fs-12 text-muted">{{ Info.VehicleCategory }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.VehicleModelName">
              <h6 class="fs-12 font-weight-bold text-dark">Vehicle Model Name</h6>
              <p class="lead fs-12 text-muted">{{ Info.VehicleModelName }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.VariantName">
              <h6 class="fs-12 font-weight-bold text-dark">Variant</h6>
              <p class="lead fs-12 text-muted">{{ Info.VariantName }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.MefgYear">
              <h6 class="fs-12 font-weight-bold text-dark">Manufacture Year</h6>
              <p class="lead fs-12 text-muted">{{ Info.MefgYear }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.VehicleRegistationNo">
              <h6 class="fs-12 font-weight-bold text-dark">Vehicle Registation No</h6>
              <p class="lead fs-12 text-muted">
                {{ Info.VehicleRegistationNo }}
                <i *ngIf="
                    Info.VehicleRegistationNo != '' &&
                    (RCKYC_IsVerified == 1 || RCLastVerfiedDate)
                  " class="fa fa-check ml-2" style="color: green"></i>
              </p>
            </div>
            <div class="col-md-2" *ngIf="Info.RegistationDate">
              <h6 class="fs-12 font-weight-bold text-dark">Registation Date</h6>
              <p class="lead fs-12 text-muted">{{ Info.RegistationDate }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.RegistationExpiryDate">
              <h6 class="fs-12 font-weight-bold text-dark">Registation Expiry Date</h6>
              <p class="lead fs-12 text-muted">{{ Info.RegistationExpiryDate }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.FuelType">
              <h6 class="fs-12 font-weight-bold text-dark">Fuel Type</h6>
              <p class="lead fs-12 text-muted">{{ Info.FuelType }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Vehicle_SubType == 'Commercial' && Info.RoadTaxUpto">
              <h6 class="fs-12 font-weight-bold text-dark">Road Tax Upto</h6>
              <p class="lead fs-12 text-muted">{{ Info.RoadTaxUpto }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Color">
              <h6 class="fs-12 font-weight-bold text-dark">Color</h6>
              <p class="lead fs-12 text-muted">{{ Info.Color }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Vehicle_SubType == 'Commercial' && Info.FitnessUpto">
              <h6 class="fs-12 font-weight-bold text-dark">Fitness Upto</h6>
              <p class="lead fs-12 text-muted">{{ Info.FitnessUpto }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Vehicle_SubType == 'Commercial' && Info.PermitUpto">
              <h6 class="fs-12 font-weight-bold text-dark">Permit Upto</h6>
              <p class="lead fs-12 text-muted">{{ Info.PermitUpto }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.VehicleCost">
              <h6 class="fs-12 font-weight-bold text-dark">Vehicle Cost</h6>
              <p class="lead fs-12 text-muted">{{ Info.VehicleCost }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Vehicle_SubType == 'Commercial' && Info.Rout">
              <h6 class="fs-12 font-weight-bold text-dark">Route</h6>
              <p class="lead fs-12 text-muted">{{ Info.Rout }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.EngineNo">
              <h6 class="fs-12 font-weight-bold text-dark">Engine No</h6>
              <p class="lead fs-12 text-muted">{{ Info.EngineNo }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.ChassisNo">
              <h6 class="fs-12 font-weight-bold text-dark">Chassis No</h6>
              <p class="lead fs-12 text-muted">{{ Info.ChassisNo }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.KeyNo">
              <h6 class="fs-12 font-weight-bold text-dark">Key No</h6>
              <p class="lead fs-12 text-muted">{{ Info.KeyNo }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.RC_HPNEndorsment">
              <h6 class="fs-12 font-weight-bold text-dark">RC HPNEndorsment</h6>
              <p class="lead fs-12 text-muted">
                {{ Info.RC_HPNEndorsment == true ? "YES" : "NO" }}
              </p>
            </div>
            <div class="col-md-2" *ngIf="Info.Vehicle_Type == 'New' && Info.Invoice_HPNEndorsment">
              <h6 class="fs-12 font-weight-bold text-dark">Invoice HPNEndorsment</h6>
              <p class="lead fs-12 text-muted">
                {{ Info.Invoice_HPNEndorsment == true ? "YES" : "NO" }}
              </p>
            </div>
          </div>

          <div class="row m-0 mt-2">
            <div class="col-md-12 p-1">
              <div class="bg-success1">Price Description:</div>
            </div>
          </div>

          <div class="row m-0 mt-3">
            <div class="col-md-2" *ngIf="Info.ExShowroom">
              <h6 class="fs-12 font-weight-bold text-dark">Ex Showroom</h6>
              <p class="lead fs-12 text-muted">{{ Info.ExShowroom }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Gst">
              <h6 class="fs-12 font-weight-bold text-dark">Gst</h6>
              <p class="lead fs-12 text-muted">{{ Info.Gst }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Insurance">
              <h6 class="fs-12 font-weight-bold text-dark">Insurance</h6>
              <p class="lead fs-12 text-muted">{{ Info.Insurance }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Tds_Tcs">
              <h6 class="fs-12 font-weight-bold text-dark">Tds_Tcs</h6>
              <p class="lead fs-12 text-muted">{{ Info.Tds_Tcs }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Accessories">
              <h6 class="fs-12 font-weight-bold text-dark">Accessories</h6>
              <p class="lead fs-12 text-muted">{{ Info.Accessories }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.EssentialKit">
              <h6 class="fs-12 font-weight-bold text-dark">Essential Kit</h6>
              <p class="lead fs-12 text-muted">{{ Info.EssentialKit }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Transportation">
              <h6 class="fs-12 font-weight-bold text-dark">Transportation</h6>
              <p class="lead fs-12 text-muted">{{ Info.Transportation }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.RTO">
              <h6 class="fs-12 font-weight-bold text-dark">RTO</h6>
              <p class="lead fs-12 text-muted">{{ Info.RTO }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.OnRoad">
              <h6 class="fs-12 font-weight-bold text-dark">OnRoad</h6>
              <p class="lead fs-12 text-muted">{{ Info.OnRoad }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Earting">
              <h6 class="fs-12 font-weight-bold text-dark">Earthing</h6>
              <p class="lead fs-12 text-muted">{{ Info.Earting }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Others">
              <h6 class="fs-12 font-weight-bold text-dark">Others</h6>
              <p class="lead fs-12 text-muted">{{ Info.Others }}</p>
            </div>
          </div>

          <div class="row m-0 mt-3" *ngIf="Info.Vehicle_Type == 'Used'">
            <div class="col-md-12">
              <h1 class="fs-12 h-b">{{ Info.Vehicle_Type }} Vehicle</h1>
            </div>
            <div class="col-md-2" *ngIf="Info.ValuationDoneBy">
              <h6 class="fs-12 font-weight-bold text-dark">Valuation Done By</h6>
              <p class="lead fs-12 text-muted">{{ Info.ValuationDoneBy }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.ValuationDate">
              <h6 class="fs-12 font-weight-bold text-dark">Valuation Date</h6>
              <p class="lead fs-12 text-muted">{{ Info.ValuationDate }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.ValuationAmount">
              <h6 class="fs-12 font-weight-bold text-dark">Valuation Amount</h6>
              <p class="lead fs-12 text-muted">{{ Info.ValuationAmount }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.ValuationType">
              <h6 class="fs-12 font-weight-bold text-dark">Valuation Type</h6>
              <p class="lead fs-12 text-muted">{{ Info.ValuationType }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.OtherValuationType">
              <h6 class="fs-12 font-weight-bold text-dark">Other Valuation Type</h6>
              <p class="lead fs-12 text-muted">{{ Info.OtherValuationType }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.OtherValuationAmt">
              <h6 class="fs-12 font-weight-bold text-dark">Other Valuation Amount</h6>
              <p class="lead fs-12 text-muted">{{ Info.OtherValuationAmt }}</p>
            </div>
          </div>

          <div class="row m-0 mt-3" *ngIf="Info.Vehicle_Type == 'New'">
            <div class="col-md-12">
              <h1 class="fs-12 h-b">{{ Info.Vehicle_Type }} Vehicle</h1>
            </div>
            <div class="col-md-2" *ngIf="Info.DealerName">
              <h6 class="fs-12 font-weight-bold text-dark">Dealer</h6>
              <p class="lead fs-12 text-muted">{{ Info.DealerName }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.DealerContactPerson">
              <h6 class="fs-12 font-weight-bold text-dark">Dealer Contact Person</h6>
              <p class="lead fs-12 text-muted">{{ Info.DealerContactPerson }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.DealerContactNo">
              <h6 class="fs-12 font-weight-bold text-dark">Dealer Contact No.</h6>
              <p class="lead fs-12 text-muted">{{ Info.DealerContactNo }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.DONo">
              <h6 class="fs-12 font-weight-bold text-dark">DO. No.</h6>
              <p class="lead fs-12 text-muted">{{ Info.DONo }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.DODoDate">
              <h6 class="fs-12 font-weight-bold text-dark">DO. Do Date</h6>
              <p class="lead fs-12 text-muted">{{ Info.DODoDate }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.EstimationAmount">
              <h6 class="fs-12 font-weight-bold text-dark">Estimation Amount</h6>
              <p class="lead fs-12 text-muted">{{ Info.EstimationAmount }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.InvoiceNo">
              <h6 class="fs-12 font-weight-bold text-dark">Invoice No.</h6>
              <p class="lead fs-12 text-muted">{{ Info.InvoiceNo }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.InvoiceDate">
              <h6 class="fs-12 font-weight-bold text-dark">Invoice Date</h6>
              <p class="lead fs-12 text-muted">{{ Info.InvoiceDate }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.InvoiceValue">
              <h6 class="fs-12 font-weight-bold text-dark">Invoice Value</h6>
              <p class="lead fs-12 text-muted">{{ Info.InvoiceValue }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.DOIssuedinfavourof">
              <h6 class="fs-12 font-weight-bold text-dark">Quotation in favour of</h6>
              <p class="lead fs-12 text-muted">{{ Info.DOIssuedinfavourof }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Remark">
              <h6 class="fs-12 font-weight-bold text-dark">Remark</h6>
              <p class="lead fs-12 text-muted">{{ Info.Remark }}</p>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 mt-2 upload" *ngIf="AssetsAttachment.length > 0">
              <b> Uploaded Vehicle Images </b>
              <div class="row m-0 mt-2 align-items-center" *ngFor="let report of AssetsAttachment; let i = index">
                <div class="col-md-1 pl-0">
                  {{ i + 1 }}
                </div>
                <div class="col-md-3">
                  <p class="lead fs-12">{{ report.Title }}</p>
                </div>
                <div class="col-md-3">
                  <p class="m-0 row">
                    <a href="{{ applicationDocUrl }}{{
                          loanSummary.ApplicationNo
                        }}/{{ report.DocFileName }}" target="_blank" *ngIf="report.DocFileName">{{ report.DocFileName
                        }}</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="text-right mb-2" style="margin-right: 3.125rem">
          </div>
        </ng-container>

        <ng-container *ngIf="Collateral == 'Gold'">
          <div class="table-responsive mt-4 mb-4">
            <mat-table [dataSource]="dataviewAssetItemSource">
              <ng-container matColumnDef="Id">
                <mat-header-cell class="grid-header" style="max-width: 3.125rem" *matHeaderCellDef>#</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="grid-cell"
                  style="max-width: 3.125rem; max-height: 0.3125rem">
                  {{ i + 1 }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="ItemName">
                <mat-header-cell class="grid-header" *matHeaderCellDef>Item Name</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{ row.ItemName }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="ItemType">
                <mat-header-cell class="grid-header" *matHeaderCellDef>Item Type</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{ row.ItemType }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="Qty">
                <mat-header-cell class="grid-header" *matHeaderCellDef>Qty</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{ row.Qty }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="PurityCT">
                <mat-header-cell class="grid-header" *matHeaderCellDef>Purity CT</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{ row.PurityCT }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="GrossWt">
                <mat-header-cell class="grid-header" *matHeaderCellDef>Gross Wt</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{ row.GrossWt }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="StoneWt">
                <mat-header-cell class="grid-header" *matHeaderCellDef>Stone Wt</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{ row.StoneWt }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="OtherWt">
                <mat-header-cell class="grid-header" *matHeaderCellDef>Other Wt</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{ row.OtherWt }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="NetWt">
                <mat-header-cell class="grid-header" *matHeaderCellDef>Net Wt</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{ row.NetWt }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="PureWt">
                <mat-header-cell class="grid-header" *matHeaderCellDef>Pure Wt</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{
                    ((row.NetWt * (row.PurityCT * fixrate24ct)) / 100).toFixed(
                    2
                    )
                    }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="ValulationRate_PerCT">
                <mat-header-cell class="grid-header" *matHeaderCellDef>Rate</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{ row.ValulationRate_PerCT }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="ValulationAmount">
                <mat-header-cell class="grid-header" *matHeaderCellDef>Amount</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  {{ row.ValulationAmount }}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="Image">
                <mat-header-cell class="grid-header" *matHeaderCellDef>View</mat-header-cell>
                <mat-cell *matCellDef="let row" class="grid-cell">
                  <a href="{{ applicationDocUrl }}{{
                        loanSummary.ApplicationNo
                      }}/{{ row.Image1 }}" target="_blank" *ngIf="row.Image1">
                    <i *ngIf="row.Image1" class="fa fa-eye" style="font-size: large"></i>
                  </a>
                  <a href="{{ applicationDocUrl }}{{
                        loanSummary.ApplicationNo
                      }}/{{ row.Image2 }}" class="ml-2" target="_blank" *ngIf="row.Image2">
                    <i *ngIf="row.Image2" class="fa fa-eye" style="font-size: large"></i>
                  </a>
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedViewAssetItemColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedViewAssetItemColumns"></mat-row>
            </mat-table>
          </div>

          <div class="row m-0 mt-3" *ngIf="Info">
            <div class="col-md-3" *ngIf="Info.ValulationDoneBy">
              <h6 class="fs-12 font-weight-bold text-dark">Valution Done By</h6>
              <p class="lead fs-12 text-muted">{{ Info.ValulationDoneBy }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.ValulationDate">
              <h6 class="fs-12 font-weight-bold text-dark">Valution Date</h6>
              <p class="lead fs-12 text-muted">{{ Info.ValulationDate }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.TotalValulationAmount">
              <h6 class="fs-12 font-weight-bold text-dark">Total Valution Amount</h6>
              <p class="lead fs-12 text-muted">{{ Info.TotalValulationAmount }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.ValuerPhoneNo">
              <h6 class="fs-12 font-weight-bold text-dark">Valuer PhoneNo</h6>
              <p class="lead fs-12 text-muted">{{ Info.ValuerPhoneNo }}</p>
            </div>
            <div class="col-md-3" *ngIf="Info.ValuerFirmName">
              <h6 class="fs-12 font-weight-bold text-dark">Valuer FirmName</h6>
              <p class="lead fs-12 text-muted">{{ Info.ValuerFirmName }}</p>
            </div>
          </div>
          <div class="text-right mb-2" style="margin-right: 3.125rem">
          </div>
        </ng-container>

        <ng-container *ngIf="Collateral == 'Consumer_Durable'">
          <div class="row m-0 mt-3" *ngIf="Info">
            <div class="col-md-2" *ngIf="Info.Category_Name">
              <h6 class="fs-12 font-weight-bold text-dark">Category Name</h6>
              <p class="lead fs-12 text-muted">{{ Info.Category_Name }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Manufacture_Name">
              <h6 class="fs-12 font-weight-bold text-dark">Manufacture Name</h6>
              <p class="lead fs-12 text-muted">{{ Info.Manufacture_Name }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Product_Name">
              <h6 class="fs-12 font-weight-bold text-dark">Product_Name</h6>
              <p class="lead fs-12 text-muted">{{ Info.Product_Name }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Model_Name">
              <h6 class="fs-12 font-weight-bold text-dark">Model Name</h6>
              <p class="lead fs-12 text-muted">{{ Info.Model_Name }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Varient">
              <h6 class="fs-12 font-weight-bold text-dark">Varient</h6>
              <p class="lead fs-12 text-muted">{{ Info.Varient }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Identification_No1">
              <h6 class="fs-12 font-weight-bold text-dark">Identification No1</h6>
              <p class="lead fs-12 text-muted">{{ Info.Identification_No1 }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Identification_No2">
              <h6 class="fs-12 font-weight-bold text-dark">Identification No2</h6>
              <p class="lead fs-12 text-muted">{{ Info.Identification_No2 }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Cost">
              <h6 class="fs-12 font-weight-bold text-dark">Cost</h6>
              <p class="lead fs-12 text-muted">{{ Info.Cost }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Color">
              <h6 class="fs-12 font-weight-bold text-dark">Color</h6>
              <p class="lead fs-12 text-muted">{{ Info.Color }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Invoice_No">
              <h6 class="fs-12 font-weight-bold text-dark">Invoice_No</h6>
              <p class="lead fs-12 text-muted">{{ Info.Invoice_No }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Invoice_Date">
              <h6 class="fs-12 font-weight-bold text-dark">Invoice Date</h6>
              <p class="lead fs-12 text-muted">{{ Info.Invoice_Date }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.Dealer_Name">
              <h6 class="fs-12 font-weight-bold text-dark">Dealer Name</h6>
              <p class="lead fs-12 text-muted">{{ Info.Dealer_Name }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.DealerContactPerson">
              <h6 class="fs-12 font-weight-bold text-dark">Dealer Contact Person</h6>
              <p class="lead fs-12 text-muted">{{ Info.DealerContactPerson }}</p>
            </div>
            <div class="col-md-2" *ngIf="Info.DealerContactNo">
              <h6 class="fs-12 font-weight-bold text-dark">Dealer Contact No</h6>
              <p class="lead fs-12 text-muted">{{ Info.DealerContactNo }}</p>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 mt-2 upload" *ngIf="AssetsAttachment.length > 0">
              <b> Uploaded Consumer Durable Images </b>
              <div class="row m-0 mt-2 align-items-center" *ngFor="let report of AssetsAttachment; let i = index">
                <div class="col-md-1 pl-0">
                  {{ i + 1 }}
                </div>
                <div class="col-md-3">
                  <p class="lead fs-12">{{ report.Title }}</p>
                </div>
                <div class="col-md-3">
                  <p class="m-0 row">
                    <a href="{{ applicationDocUrl }}{{
                          loanSummary.ApplicationNo
                        }}/{{ report.DocFileName }}" target="_blank" *ngIf="report.DocFileName">{{ report.DocFileName
                        }}</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="text-right mb-2" style="margin-right: 3.125rem">
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div> -->

<div
  class="modal fade in"
  id="View"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div
      cdkDrag
      cdkDragRootElement=".cdk-overlay-pane"
      class="modal-content modern-modal"
    >
      <!-- Modern Header -->
      <div cdkDragHandle class="modal-header modern-header">
        <div class="header-content">
          <span class="collateral-badge">{{ Collateral }}</span>
          <h5 class="modal-title">{{ Collateral_Type }}</h5>
        </div>
        <button
          type="button"
          (click)="onCloseView()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>

      <div class="modal-body modern-body">
        <!-- Vehicle Section -->
        <ng-container *ngIf="Collateral == 'Vehicle'">
          <div class="info-card" *ngIf="Info">
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-car"></i>
                {{ Info.Vehicle_SubType }} Vehicle Details
              </h2>
            </div>

            <div class="info-grid">
              <div class="info-item" *ngIf="Info.VehicleManufacture">
                <label>Vehicle Manufacture</label>
                <p>{{ Info.VehicleManufacture }}</p>
              </div>
              <div class="info-item" *ngIf="Info.VehicleCategory">
                <label>Vehicle Category</label>
                <p>{{ Info.VehicleCategory }}</p>
              </div>
              <div class="info-item" *ngIf="Info.VehicleModelName">
                <label>Model Name</label>
                <p>{{ Info.VehicleModelName }}</p>
              </div>
              <div class="info-item" *ngIf="Info.VariantName">
                <label>Variant</label>
                <p>{{ Info.VariantName }}</p>
              </div>
              <div class="info-item" *ngIf="Info.MefgYear">
                <label>Manufacturing Year</label>
                <p>{{ Info.MefgYear }}</p>
              </div>
              <div class="info-item" *ngIf="Info.VehicleRegistationNo">
                <label>Registration No</label>
                <p>
                  {{ Info.VehicleRegistationNo }}
                  <i
                    *ngIf="
                      Info.VehicleRegistationNo != '' &&
                      (RCKYC_IsVerified == 1 || RCLastVerfiedDate)
                    "
                    class="fas fa-check-circle verified-icon"
                  ></i>
                </p>
              </div>
              <div class="info-item" *ngIf="Info.RegistationDate">
                <label>Registration Date</label>
                <p>{{ Info.RegistationDate }}</p>
              </div>
              <div class="info-item" *ngIf="Info.RegistationExpiryDate">
                <label>Registration Expiry</label>
                <p>{{ Info.RegistationExpiryDate }}</p>
              </div>
              <div class="info-item" *ngIf="Info.FuelType">
                <label>Fuel Type</label>
                <p>{{ Info.FuelType }}</p>
              </div>
              <div
                class="info-item"
                *ngIf="Info.Vehicle_SubType == 'Commercial' && Info.RoadTaxUpto"
              >
                <label>Road Tax Upto</label>
                <p>{{ Info.RoadTaxUpto }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Color">
                <label>Color</label>
                <p>{{ Info.Color }}</p>
              </div>
              <div
                class="info-item"
                *ngIf="Info.Vehicle_SubType == 'Commercial' && Info.FitnessUpto"
              >
                <label>Fitness Upto</label>
                <p>{{ Info.FitnessUpto }}</p>
              </div>
              <div
                class="info-item"
                *ngIf="Info.Vehicle_SubType == 'Commercial' && Info.PermitUpto"
              >
                <label>Permit Upto</label>
                <p>{{ Info.PermitUpto }}</p>
              </div>
              <div class="info-item" *ngIf="Info.VehicleCost">
                <label>Vehicle Cost</label>
                <p class="amount">{{ Info.VehicleCost }}</p>
              </div>
              <div
                class="info-item"
                *ngIf="Info.Vehicle_SubType == 'Commercial' && Info.Rout"
              >
                <label>Route</label>
                <p>{{ Info.Rout }}</p>
              </div>
              <div class="info-item" *ngIf="Info.EngineNo">
                <label>Engine No</label>
                <p>{{ Info.EngineNo }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ChassisNo">
                <label>Chassis No</label>
                <p>{{ Info.ChassisNo }}</p>
              </div>
              <div class="info-item" *ngIf="Info.KeyNo">
                <label>Key No</label>
                <p>{{ Info.KeyNo }}</p>
              </div>
              <div
                class="info-item"
                *ngIf="
                  Info.RC_HPNEndorsment !== undefined &&
                  Info.RC_HPNEndorsment !== null
                "
              >
                <label>RC HPN Endorsement</label>
                <p>
                  <span
                    class="status-badge"
                    [class.status-yes]="Info.RC_HPNEndorsment"
                    [class.status-no]="!Info.RC_HPNEndorsment"
                  >
                    {{ Info.RC_HPNEndorsment == true ? "YES" : "NO" }}
                  </span>
                </p>
              </div>
              <div
                class="info-item"
                *ngIf="
                  Info.Vehicle_Type == 'New' &&
                  Info.Invoice_HPNEndorsment !== undefined &&
                  Info.Invoice_HPNEndorsment !== null
                "
              >
                <label>Invoice HPN Endorsement</label>
                <p>
                  <span
                    class="status-badge"
                    [class.status-yes]="Info.Invoice_HPNEndorsment"
                    [class.status-no]="!Info.Invoice_HPNEndorsment"
                  >
                    {{ Info.Invoice_HPNEndorsment == true ? "YES" : "NO" }}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <!-- Price Description -->
          <div
            class="info-card"
            *ngIf="
              Info &&
              (Info.ExShowroom ||
                Info.Gst ||
                Info.Insurance ||
                Info.Tds_Tcs ||
                Info.Accessories ||
                Info.EssentialKit ||
                Info.Transportation ||
                Info.RTO ||
                Info.OnRoad ||
                Info.Earting ||
                Info.Others)
            "
          >
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-rupee-sign"></i>
                Price Breakdown
              </h2>
            </div>

            <div class="info-grid">
              <div class="info-item" *ngIf="Info.ExShowroom">
                <label>Ex Showroom</label>
                <p class="amount">{{ Info.ExShowroom }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Gst">
                <label>GST</label>
                <p class="amount">{{ Info.Gst }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Insurance">
                <label>Insurance</label>
                <p class="amount">{{ Info.Insurance }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Tds_Tcs">
                <label>TDS/TCS</label>
                <p class="amount">{{ Info.Tds_Tcs }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Accessories">
                <label>Accessories</label>
                <p class="amount">{{ Info.Accessories }}</p>
              </div>
              <div class="info-item" *ngIf="Info.EssentialKit">
                <label>Essential Kit</label>
                <p class="amount">{{ Info.EssentialKit }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Transportation">
                <label>Transportation</label>
                <p class="amount">{{ Info.Transportation }}</p>
              </div>
              <div class="info-item" *ngIf="Info.RTO">
                <label>RTO</label>
                <p class="amount">{{ Info.RTO }}</p>
              </div>
              <div class="info-item" *ngIf="Info.OnRoad">
                <label>On Road</label>
                <p class="amount">{{ Info.OnRoad }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Earting">
                <label>Earthing</label>
                <p class="amount">{{ Info.Earting }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Others">
                <label>Others</label>
                <p class="amount">{{ Info.Others }}</p>
              </div>
            </div>
          </div>

          <!-- Used Vehicle Details -->
          <div class="info-card" *ngIf="Info && Info.Vehicle_Type == 'Used'">
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-clipboard-check"></i>
                Used Vehicle Details
              </h2>
            </div>

            <div class="info-grid">
              <div class="info-item" *ngIf="Info.ValuationDoneBy">
                <label>Valuation Done By</label>
                <p>{{ Info.ValuationDoneBy }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationDate">
                <label>Valuation Date</label>
                <p>{{ Info.ValuationDate }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationAmount">
                <label>Valuation Amount</label>
                <p class="amount">{{ Info.ValuationAmount }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationType">
                <label>Valuation Type</label>
                <p>{{ Info.ValuationType }}</p>
              </div>
              <div class="info-item" *ngIf="Info.OtherValuationType">
                <label>Other Valuation Type</label>
                <p>{{ Info.OtherValuationType }}</p>
              </div>
              <div class="info-item" *ngIf="Info.OtherValuationAmt">
                <label>Other Valuation Amount</label>
                <p class="amount">{{ Info.OtherValuationAmt }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationRemarkDoc">
                <label>Valuation Report</label>
                <p>
                  <a
                    href="{{ applicationDocUrl }}{{
                      loanSummary.ApplicationNo
                    }}/{{ Info.ValuationRemarkDoc }}"
                    target="_blank"
                    class="doc-link"
                  >
                    <i class="fas fa-file-pdf"></i>
                    {{ Info.ValuationRemarkDoc }}
                  </a>
                </p>
              </div>
              <div class="info-item" *ngIf="Info.SearchReportRemarkDoc">
                <label>Search Report</label>
                <p>
                  <a
                    href="{{ applicationDocUrl }}{{
                      loanSummary.ApplicationNo
                    }}/{{ Info.SearchReportRemarkDoc }}"
                    target="_blank"
                    class="doc-link"
                  >
                    <i class="fas fa-file-pdf"></i>
                    {{ Info.SearchReportRemarkDoc }}
                  </a>
                </p>
              </div>
            </div>
          </div>

          <!-- New Vehicle Details -->
          <div class="info-card" *ngIf="Info && Info.Vehicle_Type == 'New'">
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-store"></i>
                New Vehicle Details
              </h2>
            </div>

            <div class="info-grid">
              <div class="info-item" *ngIf="Info.DealerName">
                <label>Dealer</label>
                <p>{{ Info.DealerName }}</p>
              </div>
              <div class="info-item" *ngIf="Info.DealerContactPerson">
                <label>Contact Person</label>
                <p>{{ Info.DealerContactPerson }}</p>
              </div>
              <div class="info-item" *ngIf="Info.DealerContactNo">
                <label>Contact No.</label>
                <p>{{ Info.DealerContactNo }}</p>
              </div>
              <div class="info-item" *ngIf="Info.DONo">
                <label>DO. No.</label>
                <p>{{ Info.DONo }}</p>
              </div>
              <div class="info-item" *ngIf="Info.DODoDate">
                <label>DO. Date</label>
                <p>{{ Info.DODoDate }}</p>
              </div>
              <div class="info-item" *ngIf="Info.EstimationAmount">
                <label>Estimation Amount</label>
                <p class="amount">{{ Info.EstimationAmount }}</p>
              </div>
              <div class="info-item" *ngIf="Info.InvoiceNo">
                <label>Invoice No.</label>
                <p>{{ Info.InvoiceNo }}</p>
              </div>
              <div class="info-item" *ngIf="Info.InvoiceDate">
                <label>Invoice Date</label>
                <p>{{ Info.InvoiceDate }}</p>
              </div>
              <div class="info-item" *ngIf="Info.InvoiceValue">
                <label>Invoice Value</label>
                <p class="amount">{{ Info.InvoiceValue }}</p>
              </div>
              <div class="info-item" *ngIf="Info.DOIssuedinfavourof">
                <label>Quotation in favour of</label>
                <p>{{ Info.DOIssuedinfavourof }}</p>
              </div>
              <div class="info-item info-item-full" *ngIf="Info.Remark">
                <label>Remark</label>
                <p>{{ Info.Remark }}</p>
              </div>
            </div>
          </div>

          <!-- Vehicle Images -->
          <div
            class="info-card"
            *ngIf="AssetsAttachment && AssetsAttachment.length > 0"
          >
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-images"></i>
                Uploaded Images
              </h2>
            </div>

            <div class="attachments-list">
              <div
                class="attachment-item"
                *ngFor="let report of AssetsAttachment; let i = index"
              >
                <span class="attachment-index">{{ i + 1 }}</span>
                <span class="attachment-title">{{ report.Title }}</span>
                <a
                  href="{{ applicationDocUrl }}{{
                    loanSummary.ApplicationNo
                  }}/{{ report.DocFileName }}"
                  target="_blank"
                  *ngIf="report.DocFileName"
                  class="attachment-link"
                >
                  <i class="fas fa-external-link-alt"></i>
                  {{ report.DocFileName }}
                </a>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Gold Section -->
        <ng-container *ngIf="Collateral == 'Gold'">
          <div
            class="info-card"
            *ngIf="
              dataviewAssetItemSource &&
              dataviewAssetItemSource.data &&
              dataviewAssetItemSource.data.length > 0
            "
          >
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-gem"></i>
                Gold Info
              </h2>
            </div>

            <div class="modern-table-wrapper">
              <mat-table
                [dataSource]="dataviewAssetItemSource"
                class="modern-table"
              >
                <ng-container matColumnDef="Id">
                  <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
                  <mat-cell *matCellDef="let row; let i = index">{{
                    i + 1
                  }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="ItemName">
                  <mat-header-cell *matHeaderCellDef>Item Name</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.ItemName }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="ItemType">
                  <mat-header-cell *matHeaderCellDef>Item Type</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.ItemType }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Qty">
                  <mat-header-cell *matHeaderCellDef>Qty</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.Qty }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="PurityCT">
                  <mat-header-cell *matHeaderCellDef>Purity CT</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.PurityCT }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="GrossWt">
                  <mat-header-cell *matHeaderCellDef>Gross Wt</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.GrossWt }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="StoneWt">
                  <mat-header-cell *matHeaderCellDef>Stone Wt</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.StoneWt }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="OtherWt">
                  <mat-header-cell *matHeaderCellDef>Other Wt</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.OtherWt }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="NetWt">
                  <mat-header-cell *matHeaderCellDef>Net Wt</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.NetWt }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="PureWt">
                  <mat-header-cell *matHeaderCellDef>Pure Wt</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    {{
                      (
                        (row.NetWt * (row.PurityCT * fixrate24ct)) /
                        100
                      ).toFixed(2)
                    }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ValulationRate_PerCT">
                  <mat-header-cell *matHeaderCellDef>Rate</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{
                    row.ValulationRate_PerCT
                  }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="ValulationAmount">
                  <mat-header-cell *matHeaderCellDef>Amount</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{
                    row.ValulationAmount
                  }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Image">
                  <mat-header-cell *matHeaderCellDef>Images</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <div class="image-links">
                      <a
                        href="{{ applicationDocUrl }}{{
                          loanSummary.ApplicationNo
                        }}/{{ row.Image1 }}"
                        target="_blank"
                        *ngIf="row.Image1"
                        class="image-link"
                      >
                        <i class="fas fa-eye"></i>
                      </a>
                      <a
                        href="{{ applicationDocUrl }}{{
                          loanSummary.ApplicationNo
                        }}/{{ row.Image2 }}"
                        target="_blank"
                        *ngIf="row.Image2"
                        class="image-link"
                      >
                        <i class="fas fa-eye"></i>
                      </a>
                    </div>
                  </mat-cell>
                </ng-container>

                <mat-header-row
                  *matHeaderRowDef="displayedViewAssetItemColumns"
                ></mat-header-row>
                <mat-row
                  *matRowDef="let row; columns: displayedViewAssetItemColumns"
                ></mat-row>
              </mat-table>
            </div>
          </div>

          <div class="info-card" *ngIf="Info">
            <div class="info-grid">
              <div class="info-item" *ngIf="Info.ValulationDoneBy">
                <label>Valuation Done By</label>
                <p>{{ Info.ValulationDoneBy }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValulationDate">
                <label>Valuation Date</label>
                <p>{{ Info.ValulationDate }}</p>
              </div>
              <div class="info-item" *ngIf="Info.TotalValulationAmount">
                <label>Total Valuation Amount</label>
                <p class="amount">{{ Info.TotalValulationAmount }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuerPhoneNo">
                <label>Valuer Phone No</label>
                <p>{{ Info.ValuerPhoneNo }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuerFirmName">
                <label>Valuer Firm Name</label>
                <p>{{ Info.ValuerFirmName }}</p>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Consumer Durable Section -->
        <ng-container *ngIf="Collateral == 'Consumer_Durable'">
          <div class="info-card" *ngIf="Info">
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-tv"></i>
                Consumer Durable Details
              </h2>
            </div>

            <div class="info-grid">
              <div class="info-item" *ngIf="Info.Category_Name">
                <label>Category</label>
                <p>{{ Info.Category_Name }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Manufacture_Name">
                <label>Manufacturer</label>
                <p>{{ Info.Manufacture_Name }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Product_Name">
                <label>Product Name</label>
                <p>{{ Info.Product_Name }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Model_Name">
                <label>Model</label>
                <p>{{ Info.Model_Name }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Varient">
                <label>Variant</label>
                <p>{{ Info.Varient }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Identification_No1">
                <label>Identification No. 1</label>
                <p>{{ Info.Identification_No1 }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Identification_No2">
                <label>Identification No. 2</label>
                <p>{{ Info.Identification_No2 }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Cost">
                <label>Cost</label>
                <p class="amount">{{ Info.Cost }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Color">
                <label>Color</label>
                <p>{{ Info.Color }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Invoice_No">
                <label>Invoice No.</label>
                <p>{{ Info.Invoice_No }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Invoice_Date">
                <label>Invoice Date</label>
                <p>{{ Info.Invoice_Date }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Dealer_Name">
                <label>Dealer Name</label>
                <p>{{ Info.Dealer_Name }}</p>
              </div>
              <div class="info-item" *ngIf="Info.DealerContactPerson">
                <label>Dealer Contact Person</label>
                <p>{{ Info.DealerContactPerson }}</p>
              </div>
              <div class="info-item" *ngIf="Info.DealerContactNo">
                <label>Dealer Contact No.</label>
                <p>{{ Info.DealerContactNo }}</p>
              </div>
            </div>
          </div>

          <!-- Consumer Durable Images -->
          <div
            class="info-card"
            *ngIf="AssetsAttachment && AssetsAttachment.length > 0"
          >
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-images"></i>
                Product Images
              </h2>
            </div>

            <div class="attachments-list">
              <div
                class="attachment-item"
                *ngFor="let report of AssetsAttachment; let i = index"
              >
                <span class="attachment-index">{{ i + 1 }}</span>
                <span class="attachment-title">{{ report.Title }}</span>
                <a
                  href="{{ applicationDocUrl }}{{
                    loanSummary.ApplicationNo
                  }}/{{ report.DocFileName }}"
                  target="_blank"
                  *ngIf="report.DocFileName"
                  class="attachment-link"
                >
                  <i class="fas fa-external-link-alt"></i>
                  {{ report.DocFileName }}
                </a>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Property Section -->
        <ng-container *ngIf="Collateral == 'Property'">
          <div class="info-card" *ngIf="Info">
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-building"></i>
                Property Details
              </h2>
            </div>

            <div class="info-grid">
              <div class="info-item" *ngIf="Info.CustomerId">
                <label>Property Owner</label>
                <p>{{ Info.CustomerId }}</p>
              </div>
              <div class="info-item info-item-full" *ngIf="Info.Address">
                <label>Address</label>
                <p>{{ Info.Address }}</p>
              </div>
              <div class="info-item" *ngIf="Info.State">
                <label>State</label>
                <p>{{ Info.State }}</p>
              </div>
              <div class="info-item" *ngIf="Info.District">
                <label>District</label>
                <p>{{ Info.District }}</p>
              </div>
              <div class="info-item" *ngIf="Info.tasil">
                <label>Tehsil</label>
                <p>{{ Info.tasil }}</p>
              </div>
              <div class="info-item" *ngIf="Info.PinCode">
                <label>Pincode</label>
                <p>{{ Info.PinCode }}</p>
              </div>
              <div class="info-item" *ngIf="Info.TypeofProperty">
                <label>Type of Property</label>
                <p>{{ Info.TypeofProperty }}</p>
              </div>
              <div class="info-item" *ngIf="Info.NatureofProperty">
                <label>Nature of Property</label>
                <p>{{ Info.NatureofProperty }}</p>
              </div>
              <div class="info-item" *ngIf="Info.OwnershipType">
                <label>Ownership Type</label>
                <p>{{ Info.OwnershipType }}</p>
              </div>
              <div class="info-item" *ngIf="Info.OwnershipDocument">
                <label>Ownership Document</label>
                <p>{{ Info.OwnershipDocument }}</p>
              </div>
              <div class="info-item" *ngIf="Info.UnitofMeasurement">
                <label>Unit of Measurement</label>
                <p>{{ Info.UnitofMeasurement }}</p>
              </div>
              <div class="info-item" *ngIf="Info.TotalArea">
                <label>Total Area</label>
                <p>{{ Info.TotalArea }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ConstructedArea">
                <label>Constructed Area</label>
                <p>{{ Info.ConstructedArea }}</p>
              </div>
              <div class="info-item" *ngIf="Info.TypeofMortgage">
                <label>Type of Mortgage</label>
                <p>{{ Info.TypeofMortgage }}</p>
              </div>
              <div class="info-item" *ngIf="Info.MortgageSingedBy">
                <label>Mortgage Signed By</label>
                <p>{{ Info.MortgageSingedBy }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Cersai_No">
                <label>CERSAI No</label>
                <p>{{ Info.Cersai_No }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationAmount">
                <label>Valuation Amount</label>
                <p class="amount">{{ Info.ValuationAmount }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationDoneBy">
                <label>Valuation Done By</label>
                <p>{{ Info.ValuationDoneBy }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationRemark">
                <label>Valuation Remark</label>
                <p>{{ Info.ValuationRemark }}</p>
              </div>
              <div
                class="info-item"
                *ngIf="
                  Info.ValuationDoneByID != '' &&
                  Info.ValuationDoneByID == 0 &&
                  Info.ValuationDoneByOther
                "
              >
                <label>Valuation Done By Name</label>
                <p>{{ Info.ValuationDoneByOther }}</p>
              </div>
              <div class="info-item" *ngIf="Info.SearchReportDoneBy">
                <label>Search Report Done By</label>
                <p>{{ Info.SearchReportDoneBy }}</p>
              </div>
              <div class="info-item" *ngIf="Info.SearchReportRemark">
                <label>Search Report Remark</label>
                <p>{{ Info.SearchReportRemark }}</p>
              </div>
              <div
                class="info-item"
                *ngIf="
                  Info.SearchReportDoneByID != '' &&
                  Info.SearchReportDoneByID == 0 &&
                  Info.SearchReportDoneByOther
                "
              >
                <label>Search Report Done By Name</label>
                <p>{{ Info.SearchReportDoneByOther }}</p>
              </div>
              <div
                class="info-item"
                *ngIf="
                  Info.GeoLocation &&
                  Info.GeoLocation != '' &&
                  Info.GeoLocation != null &&
                  Info.GeoLocation != ','
                "
              >
                <label>Location</label>
                <p>
                  <a
                    target="_blank"
                    [href]="'http://maps.google.com/maps?q=' + Info.GeoLocation"
                    class="location-link"
                  >
                    <i class="fas fa-map-marker-alt"></i>
                    View on Map
                  </a>
                </p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationRemarkDoc">
                <label>Valuation Report</label>
                <p>
                  <a
                    href="{{ applicationDocUrl }}{{
                      loanSummary.ApplicationNo
                    }}/{{ Info.ValuationRemarkDoc }}"
                    target="_blank"
                    class="doc-link"
                  >
                    <i class="fas fa-file-pdf"></i>
                    {{ Info.ValuationRemarkDoc }}
                  </a>
                </p>
              </div>
              <div class="info-item" *ngIf="Info.SearchReportRemarkDoc">
                <label>Search Report</label>
                <p>
                  <a
                    href="{{ applicationDocUrl }}{{
                      loanSummary.ApplicationNo
                    }}/{{ Info.SearchReportRemarkDoc }}"
                    target="_blank"
                    class="doc-link"
                  >
                    <i class="fas fa-file-pdf"></i>
                    {{ Info.SearchReportRemarkDoc }}
                  </a>
                </p>
              </div>
            </div>
          </div>

          <!-- Property Images -->
          <div
            class="info-card"
            *ngIf="AssetsAttachment && AssetsAttachment.length > 0"
          >
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-images"></i>
                Property Images
              </h2>
            </div>

            <div class="attachments-list">
              <div
                class="attachment-item"
                *ngFor="let report of AssetsAttachment; let i = index"
              >
                <span class="attachment-index">{{ i + 1 }}</span>
                <span class="attachment-title">{{ report.Title }}</span>
                <a
                  href="{{ applicationDocUrl }}{{
                    loanSummary.ApplicationNo
                  }}/{{ report.DocFileName }}"
                  target="_blank"
                  *ngIf="report.DocFileName"
                  class="attachment-link"
                >
                  <i class="fas fa-external-link-alt"></i>
                  {{ report.DocFileName }}
                </a>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
